import { createContext } from 'react'
import type { Theme } from './types.ts'

/**
 * React context carrying the current theme. Populated by `WithTheme` (from
 * the global persisted store) and `ScopedTheme` (from an explicit prop).
 * `useTheme` reads from this context with a fallback to the store, so
 * nested `ScopedTheme` boundaries let subtrees render under a different
 * theme without mutating global state.
 */
export const ThemeContext = createContext<Theme | undefined>(undefined)
